import type { FC } from "react";

import { NavRow } from "@/components/ui/nav-row";
import { paneTitleClass } from "@/components/ui/pane-header";
import { PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

import {
  deadlineUrgency,
  formatDeadline,
  relativeDeadline
} from "../header/caseHeaderModel";
import { useSharedCaseDetails } from "../header/caseDetailsStore";
import { DeadlinePopover } from "../header/chips/DeadlineChip";

/** The explorer's Filing Deadline row: the date, tinted as it nears, and a calendar to set it. */
export const FilingDeadlineHeader: FC<{ individualId: string }> = ({
  individualId
}) => {
  const details = useSharedCaseDetails(individualId);
  if (!details) return null;
  const iso = details.filingDeadline;
  const label = formatDeadline(iso);
  const urgency = deadlineUrgency(iso);

  return (
    <DeadlinePopover
      value={iso}
      onChange={details.setFilingDeadline}
      align="end"
    >
      <PopoverTrigger asChild>
        <NavRow
          data-testid="filing-deadline-header"
          title={label ? `Due ${relativeDeadline(iso)}` : undefined}
          trailing={
            <span
              className={cn(
                "tabular-nums",
                urgency === "overdue"
                  ? "text-danger"
                  : urgency === "soon"
                  ? "text-warn"
                  : label
                  ? "text-fg-3"
                  : "text-fg-4"
              )}
            >
              {label || "Add date"}
            </span>
          }
        >
          <span className={paneTitleClass}>Filing Deadline</span>
        </NavRow>
      </PopoverTrigger>
    </DeadlinePopover>
  );
};
